import { useState } from 'react';
import { Button, Center, Loader, Text } from '@mantine/core';
import { closeModal, openModal } from '@mantine/modals';
import { i18n } from '@lingui/core';
import GenericTemplateName from '../GenericTemplateName';
import { DocumentTemplateS } from '../../../Service/DocumenteTemplateS';

const RENAME_DOCUMENT_TEMPLATE_MODAL_ID = 'rename-document-template-modal';

export const openRenameDocumentTemplateModal = ({ templateId, templateName, documentType, onRename }) => {
  openModal({
    modalId: RENAME_DOCUMENT_TEMPLATE_MODAL_ID,
    size: 'sm',
    title: (
      <Text weight="bolder" size="xl" sx={{ lineHeight: 1.2 }}>
        Name der Vorlage ändern
      </Text>
    ),
    closeOnEscape: true,
    transition: 'slide-down',
    children: (
      <RenameDocumentTemplateModal
        templateId={templateId}
        templateName={templateName}
        documentType={documentType}
        onRename={onRename}
      />
    ),
  });
};

const RenameDocumentTemplateModal = ({ templateId, templateName, documentType, onRename }) => {
  const [newName, setNewName] = useState(templateName);
  const [disableSave, setDisableSave] = useState(false);
  const [loading, setLoading] = useState(false);

  const changeName = async () => {
    setLoading(true);
    const trimmedName = newName.trim();
    const resJSON = await DocumentTemplateS.edit(templateId, { name: trimmedName });
    if (resJSON) {
      onRename?.(trimmedName, resJSON);
      closeModal(RENAME_DOCUMENT_TEMPLATE_MODAL_ID);
    } else {
      setLoading(false);
    }
  };

  return (
    <>
      <Text mb="sm">Wähle einen Namen für diese Vorlage:</Text>
      <GenericTemplateName
        disableSave={setDisableSave}
        documentType={documentType}
        name={templateName}
        newName={newName}
        setNewName={setNewName}
        groupName={undefined}
        setGroupName={undefined}
        existingGroups={undefined}
      />
      <Center mt="xl">
        <Button
          onClick={changeName}
          disabled={disableSave || loading}
          rightIcon={loading && <Loader size="xs" />}
          sx={{ width: 200 }}
        >
          {i18n._('actions.save')}
        </Button>
      </Center>
    </>
  );
};
